import { Injectable } from '@angular/core';
import {
  ResumoFinanceiroModel,
  TitulosLiquidadosModel,
  ComparacaoTitulosLiquidadosModel,
  ConciliacaoCartoesRowModel,
  ConciliacaoCartoesAdquirenteModel,
  ConciliacaoCartoesQueryPayload,
} from '@app/data';
import { ApiService } from '@app/gateway';
import type { DashPeriodQueryPayload } from '@app/pages/dashboard/shared';

@Injectable({ providedIn: 'root' })
export class ReceberService {
  constructor(protected readonly apiService: ApiService) {}

  public async receberTitulos(data: DashPeriodQueryPayload): Promise<TitulosLiquidadosModel[]> {
    try {
      const path: string = `receber/receberTitulos`;
      const result: TitulosLiquidadosModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load receivable titles.';
      throw new Error(message, { cause: e });
    }
  }

  public async receberTitulosVencidos(data: DashPeriodQueryPayload): Promise<ResumoFinanceiroModel> {
    try {
      const path: string = `receber/titulosVencidos`;
      const result: ResumoFinanceiroModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load overdue receivables.';
      throw new Error(message, { cause: e });
    }
  }

  public async receberTitulosLiquidados(data: DashPeriodQueryPayload): Promise<ResumoFinanceiroModel> {
    try {
      const path: string = `receber/titulosLiquidados`;
      const result: ResumoFinanceiroModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load settled receivables.';
      throw new Error(message, { cause: e });
    }
  }

  public async receberTitulosVencidosAberto(data: DashPeriodQueryPayload): Promise<ResumoFinanceiroModel> {
    try {
      const path: string = `receber/titulosVencidosAberto`;
      const result: ResumoFinanceiroModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load open overdue receivables.';
      throw new Error(message, { cause: e });
    }
  }

  public async receberTitulosAtrasados(data: DashPeriodQueryPayload): Promise<ResumoFinanceiroModel> {
    try {
      const path: string = `receber/titulosAtrasados`;
      const result: ResumoFinanceiroModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load late receivables.';
      throw new Error(message, { cause: e });
    }
  }

  public async receberComparacaoTitulosLiquidados(
    data: Pick<DashPeriodQueryPayload, 'idAccounts'> & { anos: number[] }
  ): Promise<ComparacaoTitulosLiquidadosModel[]> {
    try {
      const path: string = `receber/comparacaoTitulosLiquidados`;
      const result: ComparacaoTitulosLiquidadosModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load receivable comparison.';
      throw new Error(message, { cause: e });
    }
  }

  public async receberConciliacaoCartoes(data: ConciliacaoCartoesQueryPayload): Promise<ConciliacaoCartoesRowModel[]> {
    try {
      const path: string = `receber/conciliacaoCartoes`;
      const result: ConciliacaoCartoesRowModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load card reconciliation entries.';
      throw new Error(message, { cause: e });
    }
  }

  public async receberConciliacaoCartoesAdquirentes(data: Pick<DashPeriodQueryPayload, 'idAccounts'>): Promise<ConciliacaoCartoesAdquirenteModel[]> {
    try {
      const path: string = `receber/conciliacaoCartoesAdquirentes`;
      const result: ConciliacaoCartoesAdquirenteModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load card acquirer catalog.';
      throw new Error(message, { cause: e });
    }
  }
}
